// extracted by mini-css-extract-plugin
export var actionButton = "_ra-0";
export var actionMenuContainer = "_ra-i";
export var bubble = "_ra-2";
export var bubbleActionMenu = "_ra-j";
export var bubbleContext = "_ra-6";
export var bubbleItems = "_ra-7";
export var customer = "_ra-3";
export var divider = "_ra-8";
export var fileList = "_ra-9";
export var hiddenComment = "_ra-o";
export var infoAbove = "_ra-a";
export var internal = "_ra-4";
export var lightActionButton = "_ra-1";
export var link = "_ra-b";
export var merchant = "_ra-5";
export var message = "_ra-c";
export var profilePicture = "_ra-e";
export var quillToolbarContainer = "_ra-f";
export var senderDate = "_ra-g";
export var senderDateCustomer = "_ra-h";
export var senderName = "_ra-d";
export var time = "_ra-k";
export var uploadedImage = "_ra-l";
export var username = "_ra-m";
export var xsmall = "_ra-n";